export default {
  stageGoal: null
}
